import { Component, OnInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { CCExpiredReport } from '../../../../models/reports/expired-credit-card-report';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store';

@Component({
  selector: 'app-credit-card-report',
  templateUrl: './credit-card-report.component.html',
  styleUrls: ['./credit-card-report.component.css']
})
export class CreditCardReportComponent extends ReportBase implements OnInit {

  report: CCExpiredReport;
  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'date', type: 'date', title: 'Date' },
    { name: 'team', type: 'text', title: 'Team' },
    { name: 'fee', type: 'text', title: 'Fee' },
    { name: 'gender', type: 'select', title: 'Gender', options: [ { text: 'Male', value: 'm' }, { text: 'Female', value: 'f' } ] },
    { name: 'by', type: 'text', title: 'By' },
    { name: 'reason', type: 'text', title: 'Reason' },
    { name: 'credit', type: 'text', title: 'Credit' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getExpiredCreditCardReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/credit-card-report/credit-card-report.component.ts